import React, { useEffect, useState } from "react";
import { Stack, Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../layout/dashboard/header";
import { InputCustom } from "../../components/UIElements/input-ui";

import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../hooks/useAuth";
import { getUrlPathId } from "../../utils/url-id";
import { useNotificationService } from "../../components/notification";
import { UsersDataProps, UsersDummyData } from "../../interface/users";
import UsersDetailsContent from "../../components/users/UsersDetailsContent";
import { apiGetUser } from "../../api/users";
import {
  DeleteUserAccount,
  SuspendUserAccount,
} from "../../components/users/modal-user";
import BackButton from "../../components/UIElements/BackButton";

const UsersDetails = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const [refresh, setRefresh] = useState(false);
  const [user_info, setUser_info] = useState<UsersDataProps>(UsersDummyData);
  const [modal_suspend, setModal_suspend] = useState(false);
  const [modal_delete, setModal_delete] = useState(false);

  useEffect(() => {
    const userId = getUrlPathId(location?.pathname);
    const fields = { userId, token };
    mutation.mutate(fields);
  }, [refresh]);

  const mutation = useMutation({
    mutationFn: (fields: { token: string; userId: string }) =>
      apiGetUser(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        
        setUser_info(data?.data?.data);
      }
    },
    onError: (error) => {
      console.error("Fetch process failed", error);
      showNotification("Fetch process failed", "error");
    },
  });
  const handleSuspendModal = () => {
    setModal_suspend(!modal_suspend);
  };
  const handleDeleteModal = () => {
    setModal_delete(!modal_delete);
  };
  const handleRefresh = () => {
    setRefresh(!refresh);
  };
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              User Information
            </Typography>
          </Stack>
        </Box>
      </Header>
      <UsersDetailsContent
        handleRefresh={handleRefresh}
        userInfo={user_info}
        handleSuspendModal={handleSuspendModal}
        handleDeleteModal={handleDeleteModal}
      />
      <SuspendUserAccount
        open={modal_suspend}
        modalHandler={handleSuspendModal}
      />
      <DeleteUserAccount open={modal_delete} modalHandler={handleDeleteModal} />
    </>
  );
};

export default UsersDetails;
